var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip46_2061"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Huge-icon/time and date/solid/alarm-check",
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip46_2061)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "combo sape",
    d: "M17.104 1.31277C16.7246 1.14682 16.2822 1.31994 16.1162 1.69946C15.9502 2.07896 16.1235 2.52116 16.5029 2.68712C18.4932 3.55748 20.1841 4.98796 21.3755 6.77961C21.605 7.12454 22.0703 7.21825 22.4155 6.98891C22.7603 6.75957 22.854 6.29403 22.6245 5.9491C21.2754 3.92017 19.3608 2.29963 17.104 1.31277ZM7.49707 2.68712C7.87646 2.52116 8.0498 2.07896 7.88379 1.69946C7.71777 1.31994 7.27588 1.14682 6.896 1.31277C4.63965 2.29964 2.72461 3.92017 1.37549 5.9491C1.146 6.29403 1.23975 6.75957 1.58496 6.98891C1.92969 7.21825 2.39551 7.12454 2.62451 6.77961C3.81592 4.98796 5.50684 3.55748 7.49707 2.68712ZM12 4C7.02979 4 3 8.02943 3 13C3 15.1481 3.75293 17.1205 5.00879 18.6677L3.34619 21.6331C3.14355 21.9944 3.27197 22.4515 3.6333 22.6541C3.99463 22.8567 4.45166 22.728 4.6543 22.3667L6.09717 19.7937C7.67725 21.168 9.7417 22 12 22C14.2588 22 16.3232 21.168 17.9033 19.7938L19.3462 22.3667C19.5488 22.728 20.0059 22.8567 20.3672 22.6541C20.7285 22.4515 20.8569 21.9944 20.6543 21.6331L18.9917 18.6678C20.2476 17.1205 21 15.1481 21 13C21 8.02943 16.9707 4 12 4ZM15.5645 11.4939C15.8374 11.1822 15.8057 10.7083 15.4941 10.4356C15.1821 10.1628 14.7085 10.1944 14.4355 10.5061L11.5659 13.786C11.4775 13.8867 11.3257 13.9002 11.2212 13.8166L9.46875 12.4144C9.14502 12.1556 8.67334 12.208 8.41455 12.5315C8.15576 12.8549 8.20801 13.3269 8.53174 13.5857L10.2842 14.9879C11.0156 15.573 12.0776 15.4786 12.6943 14.7738L15.5645 11.4939Z",
    clipRule: "evenodd",
    fill: "#0478FE",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.4d5c21c00974029f3092855e6bf2c5c2.svg";
export { ForwardRef as ReactComponent };